import {routes} from '@utilities/constants/routes.tsx'
import {generatePath} from 'react-router-dom'
import {FC, useMemo} from 'react'
import {UserExtended} from '@/features/users/types.ts'
import {useTranslation} from '@/translations/i18n.tsx'
import {Settings01Icon, User01Icon, ClockRewindIcon} from '@components/ui/icon/Icon.tsx'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'
import {Tab, Tabs, TabWarning} from '@/components/ui/tab-atoms/TabAtoms'

export const UserDetailsTabs: FC<{user: UserExtended}> = ({user}) => {
    const {t} = useTranslation()
    const hasUserWarnings = useMemo(
        () => !!user.fieldsToCompile?.length || !!user.fieldsToUpdate?.length,
        [user.fieldsToCompile, user.fieldsToUpdate]
    )

    return (
        <Tabs paddingX={4}>
            <Tab to={generatePath(routes.USER_DETAILS_INFORMATION.handle.path, {id: user.id})}>
                <Flexbox align="center" gap={1}>
                    <User01Icon />
                    {t('users:information')}
                </Flexbox>

                {hasUserWarnings && <TabWarning />}
            </Tab>
            <Tab to={generatePath(routes.USER_DETAILS_AVAILABILITY.handle.path, {id: user.id})}>
                <Flexbox align="center" gap={1}>
                    <ClockRewindIcon />
                    {t('users:availability')}
                </Flexbox>
            </Tab>
            <Tab to={generatePath(routes.USER_DETAILS_ACCESS_PROFILE.handle.path, {id: user.id})}>
                <Flexbox align="center" gap={1}>
                    <Settings01Icon />
                    {t('users:access_profile')}
                </Flexbox>
            </Tab>
        </Tabs>
    )
}
